import React, {ReactNode} from 'react'
import {Field} from 'react-final-form'
import styles from './CheckField.scss'

const CheckField = (
  {children, name, isVan, defaultValue}: {
    name: string
    children: ReactNode
    isVan?: boolean
    defaultValue?: boolean
  }
) => <div className="custom-control custom-checkbox">
    <Field className={['custom-control-input', isVan && styles.inputVan].filter(Boolean).join(' ')}
           component="input"
           type="checkbox"
           defaultValue={defaultValue}
           name={name}
           id={name}
          />
    <label className={['custom-control-label', isVan && styles.labelVan].filter(Boolean).join(' ')}
           htmlFor={name}>
      {children}
    </label>
  </div>
CheckField.displayName = 'CheckField'
export default CheckField
